import React, { Suspense } from 'react';
import { ErrorBoundary } from 'utils/error';
import { useRouteMatch } from 'react-router-dom';

import { randomArray } from 'utils/randomArray';

import Sidebar from 'modules/fleet/sidebar';

import FleetFilters from 'modules/fleet/filters';
import GateKeepingFilters from 'modules/gatekeeping/filters';

import GatekeepingListHeader from 'modules/gatekeeping/list-header';
import GatekeepingListItem from 'modules/gatekeeping/list-item';

import { GatekeepingProvider } from 'modules/gatekeeping/provider';
import { SetToManualFlowContextProvider } from 'modules/set-to-manual-flow/context';

const GateKeepingListLazy = React.lazy(() => import('modules/gatekeeping/list'));

const t = {
  error: 'Something went wrong',
};

const LoadingFallback = () => (
  <>
    <GatekeepingListHeader loading />
    {randomArray(5, 20).map((key) => (
      <GatekeepingListItem key={key} loading />
    ))}
  </>
);

const ErrorFallback = () => <div className="error">{t.error}</div>;

const GateKeepingSection = ({ className, parentUrl }) => {
  const match = useRouteMatch();
  return (
    <GatekeepingProvider>
      <SetToManualFlowContextProvider>
        <div className={className}>
          <FleetFilters appendFilters={<GateKeepingFilters />} />
          <div className="section__wrapper">
            <Sidebar parentUrl={parentUrl} section="gatekeeping" />
            <div className="section__content">
              <Suspense fallback={<LoadingFallback />}>
                <ErrorBoundary fallback={<ErrorFallback />}>
                  <GateKeepingListLazy parentUrl={match?.url} />
                </ErrorBoundary>
              </Suspense>
            </div>
          </div>
        </div>
      </SetToManualFlowContextProvider>
    </GatekeepingProvider>
  );
};

export default GateKeepingSection;
